module.exports = __webpack_public_path__ + "img/listing-placeholder_bk.4b99e07.png";